<template>
  <div>
    <div class="container-buttons">
      <router-link to="/cadastrar-motorista"><button class="btn-custom btn-cobranca mb-3">
        <i class="fa fa-plus"></i> Cadastrar Motorista
      </button>
      </router-link>
    </div>
    <card title="Motoristas Cadastrados" subTitle="Lista de motoristas">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>RG</th>
            <th>Admissão</th>
            <th>Função</th>
            <th>CNH</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="driver in drivers" :key="driver.id">
              <td>{{ driver.id }}</td>
              <td>{{ driver.name }}</td>
              <td>{{ driver.taxId }}</td>
              <td>{{ driver.nationalId }}</td>
              <td>{{ driver.admissionAt.split('T')[0] }}</td>
              <td>{{ driver.role }}</td>
              <td>{{ driver.drivingLicense }}</td>
              <td>
                <router-link :to="`/motoristas-cadastrados/${driver.id}`">
                  <p-button type="info" outline icon title="Visualizar Motorista">
                    <i class="fa fa-eye"></i>
                  </p-button>
                </router-link>
                <p-button v-if="userRole === 'admin'" @click.prevent.native="deleteDriver(driver.id)" type="danger" outline icon title="Apagar Motorista">
                  <i class="fa fa-ban btn-delete"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="pagination.currentPage"
      :totalPages="pagination.totalPages"
      v-on:update="updatePagination"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination
  },
  computed: {
    drivers() {
      return this.$store.getters.drivers;
    },
    pagination() {
      return this.$store.getters.driversPagination;
    },
    userRole() {
      return this.$store.getters.user.role;
    }
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["fetchDrivers", "removeDriver"]),
    showModal() {
      this.$modal.show("modal");
    },
    async updatePagination({ currentPage }) {
      await this.fetchDrivers({ currentPage });
    },
    async deleteDriver(id) {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá apagar o motorista, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.removeDriver({ id });
          Swal.fire({
            title: "Sucesso!",
            text: "Motorista apagado com sucesso",
            icon: "success"
          });
        } catch (e) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível apagar o motorista",
            icon: "error"
          });
        }
      }
    },
  },
  async mounted() {
    try {
      await this.fetchDrivers();
    } catch (err) {
      Swal.fire("Ops!", "Não foi possível carregar os motoristas", "error");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-title {
  font-size: 20px;
}
.btn-modal {
  padding: 10px 60px;
}
.container-body {
  display: flex;

  p {
    font-size: 16px;
  }
}
.container-buttons {
  display: flex;
  justify-content: space-between;

  a {
    cursor: pointer;
  }
}
i.btn-config {
  font-size: 40px;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }

  &.btn-stop-cobranca {
    background: #b80a0a;

    &:hover {
      background: #700202;
    }
  }

  &.btn-cron-cobranca {
    background: #ebb000;

    &:hover {
      background: #9c7500;
    }
  }

  &.btn-modal {
    padding: 10px 50px;
  }
}

.btn-outline-success {
  border-color: #9dcf6b;
  color: #9dcf6b;

  &:hover {
    background: #9dcf6b;
    border-color: #9dcf6b;
  }
}

.btn-outline-warning {
  border-color: #ffc107;
  color: #ffc107;

  &:hover {
    background: #ffc107 !important;
    background-color: #ffc107 !important;
    border-color: #ffc107;
  }
}

.modalPhones {
  ul {
    font-size: 18px;
    li {
      list-style: none;
    }
  }
}
</style>
<style>
@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
}
</style>

